// extracted by mini-css-extract-plugin
export default {"embla__slide":"ScrollingLogos_embla__slide__d9fLH"};